module.exports = __webpack_public_path__ + "assets/img/order_2.8d8c0c88.svg";